module.exports = __webpack_public_path__ + "static/media/Hero_Spot_1.59c6a307.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/Hero_Spot_1.mp4
// module id = 80
// module chunks = 0